import { render, staticRenderFns } from "./ImportSubstanceList.vue?vue&type=template&id=375983d7&scoped=true&"
import script from "./ImportSubstanceList.vue?vue&type=script&lang=js&"
export * from "./ImportSubstanceList.vue?vue&type=script&lang=js&"
import style0 from "./ImportSubstanceList.vue?vue&type=style&index=0&id=375983d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375983d7",
  null
  
)

export default component.exports